import {Button, ThemeProvider} from "@mui/material"
import {Col, Input, message, Modal, Row, Select, Switch, Typography} from "antd"
import {aclPermissions, hasPermissions} from "const/ACLPermissions"
import {post} from "helper/request"
import React, {Component} from "react"
import cookie from "react-cookies"
import {updateGroups} from "../../../redux_actions/users.action";
import {connect} from "react-redux";
import {isSuperuser, notNull} from "../../../utils/utils";
import {defaultTheme} from "../../gammaviewer/themes";


class AddGroupButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            editMode: false,
            name: "",
            error_msg: "",
            org_id: "",
        }

        this.is_superuser = isSuperuser()
        this.organisation = cookie.load("organisation") || cookie.load("organisation_id")
    }

    createGroup = () => {
        if (!this.state.name) return

        this.setState({ loading: true })

        post('/api/create_group/',
            {
                group: this.state.name,
                organisation: this.is_superuser && this.state.externalOrg ? this.state.org_id : this.organisation
            })
            .then((data) => {
                message.success(`Successfully created group "${this.state.name}"`)
                this.setState({ editMode: false, name: "", error_msg: "" })
                // Load the new group data into our reducer
                if (notNull(data?.res)) {
                    this.props.dispatch(updateGroups(data?.res))
                }

            })
            .catch(err => {
                const resp_mesg = err?.response?.data
                let error_msg;
                if (resp_mesg.includes("already exists")) {
                    error_msg = `Group ${this.state.name} already exists. Try a different Group Name`
                } else {
                    error_msg = "Something went wrong during group creation."
                }
                this.setState({error_msg})
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }

    openModal = () => {
        this.setState({editMode: true});
    };

    closeModal = () => {
        this.setState({editMode: false, name: ''});
    };

    changeExternalOrg = (checked) => {
        this.setState({
            externalOrg: checked,
            org_id: !checked ? '' : this.state.org_id,
        });
    }

    changeOrg = (value) => {
        this.setState({
            org_id: value,
        });
    }

    filterOption = (input, option) => option.props.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0

    render() {
        const {name, loading, editMode} = this.state;
        return <>
            {editMode ? (
                <React.Fragment>
                    <ThemeProvider theme={defaultTheme}>
                        <Modal
                            title="Add New Group"
                            visible={editMode}
                            onCancel={this.closeModal}
                            footer={null}
                        >
                            <Row gutter={[0, 12]}>
                                <Col span={24}>
                                    <Input
                                        value={name}
                                        onChange={(e) => this.setState({name: e.target.value})}
                                        placeholder="Group Name"
                                    />
                                </Col>
                                {this.is_superuser &&
                                    <Col span={10}><Typography>External Organisation</Typography></Col>}
                                {this.is_superuser && <Col span={14}><Switch checked={this.state.externalOrg}
                                                                             onChange={this.changeExternalOrg}/></Col>}
                                {this.is_superuser && this.state.externalOrg && <React.Fragment>
                                    <Col span={5}>
                                        <Typography>Organisation</Typography>
                                    </Col>
                                    <Col span={18} offset={1}>
                                        <Select
                                            showSearch
                                            placeholder="Select Organisation"
                                            style={{width: '100%'}}
                                            filterOption={this.filterOption}
                                            value={this.state.org_id}
                                            onChange={this.changeOrg}>
                                            {this.props.allOrganisations.map((org) => {
                                                return <Select.Option value={org?.id}>{org?.name}</Select.Option>
                                            })
                                            }
                                        </Select>
                                    </Col></React.Fragment>}
                                <Col span={24}><Typography
                                    style={{color: "red", height: "20px"}}>{this.state.error_msg}</Typography></Col>
                            </Row>
                            <Button color="primary" variant="outlined" size="small" loading={loading}
                                    onClick={this.createGroup}
                                    style={{marginTop: '10px', marginLeft: 'auto', display: 'block'}}>
                                Create Group
                            </Button>
                        </Modal>
                        <Button
                            color="primary"
                            variant="outlined"
                            size="small"
                            disabled={!hasPermissions([aclPermissions.create_group])}
                            onClick={this.openModal}
                        >
                            Add New Group
                        </Button>
                    </ThemeProvider>
                </React.Fragment>

            ) : (
                <ThemeProvider theme={defaultTheme}>
                    <Button
                        color="primary"
                        variant="outlined"
                        size="small"
                        disabled={!hasPermissions([aclPermissions.create_group])}
                        onClick={this.openModal}
                    >
                        Add New Group
                    </Button>
                </ThemeProvider>
            )}
        </>
    }
}

const mapStateToProps = state => {
    return {
        allOrganisations: state.searchUserReducer.organisations,
    };
};

export default connect(mapStateToProps)(AddGroupButton);